import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { maskCardNumber } from '../../../../../util';
import { clearToolsRbiStore } from '../../../../../actions/creatorsSync';
import {
  Title,
  SuccessWrapper,
  SuccessIcon,
  SuccessCard,
  CardRow,
  CardRowTitle,
  CardRowValue,
} from './DTRbiGiftCardInfoWidget.styles';

const DTRbiGiftCardInfoWidget = () => {
  const dispatch = useDispatch();
  const transaction = useSelector((state) => state.tools.decisionTree.rbi.transaction);

  useEffect(() => {
    return () => {
      dispatch(clearToolsRbiStore());
    };
  }, [dispatch]);

  return (
    <SuccessWrapper>
      <SuccessIcon src={'/images/check-mark.svg'} alt="check-mark" />
      <Title>Transaction Successful!</Title>
      <SuccessCard>
        <CardRow>
          <CardRowTitle>Destination Card:</CardRowTitle>
          <CardRowValue>{maskCardNumber(transaction.cardNumber)}</CardRowValue>
        </CardRow>
        <CardRow>
          <CardRowTitle>Current Balance:</CardRowTitle>
          <CardRowValue>${transaction.currentBalance}</CardRowValue>
        </CardRow>
        <CardRow>
          <CardRowTitle>Transaction #:</CardRowTitle>
          <CardRowValue>{transaction.transactionId}</CardRowValue>
        </CardRow>
      </SuccessCard>
    </SuccessWrapper>
  );
};

export default DTRbiGiftCardInfoWidget;
